const contactFormHandler = (contactForm) => {
  const showSuccess = () => {
    closeModal();

    const openModalButton = document.querySelectorAll('.js-modal-open');
    const successMessage = document.querySelectorAll('.js-contact-success');

    openModalButton.forEach((element) => element.setAttribute('hidden','hidden'));
    successMessage.forEach((element) => element.removeAttribute('hidden'));

    setTimeout(() => {
      openModalButton.forEach((element) => element.removeAttribute('hidden'));
      successMessage.forEach((element) => element.setAttribute('hidden','hidden'));
    }, 5000);
  };

  contactForm.addEventListener('submit', (event) => {
    event.preventDefault();

    const xhr = new XMLHttpRequest();
    xhr.open('POST', contactForm.getAttribute('action'));
    xhr.send(new FormData(event.target));

    xhr.onload = () => {
      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        if (response.success) {
          showSuccess();
          event.target.reset();
        }
      }
    };

    xhr.onerror = () => {
    };

  });
};

document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector('#js-contact-form');
  if(form){
    contactFormHandler(form);
  }
});
